<template>
  <div class="addressSelect">
        <el-select v-model="form.province" placeholder="请选择省份" @change="changeProvince" clearable style="width:120px">
            <el-option
                v-for="item in province"
                :key="item.name"
                :label="item.value"
                :value="item"
                >
            </el-option>
        </el-select>
        <el-select v-if="form.province" v-model="form.city" placeholder="请选择城市" @change="changeCity" clearable style="width:120px">
            <el-option
                v-for="item in city"
                :key="item.name"
                :label="item.value"
                :value="item">
            </el-option>
        </el-select>
        <el-select v-if="form.city" v-model="form.area" placeholder="请选择地区" @change="changeArea" clearable style="width:120px">
            <el-option
                v-for="item in area"
                :key="item.name"
                :label="item.value"
                :value="item">
            </el-option>
        </el-select>
  </div>
</template>

<script>
import allAddressInfo from '../../../../static/js/address.json'//获的本地json的数据
let that;
export default {
    name:'addressSelect',
    data(){
        return{
            form:{
                province:'',
                city:'',
                area:''
            },
            addressData:null,
            province:[],
            city:[],
            area:[]
        }
    },
    mounted(){
        that = this
        let addressData = this.$deepCopy(allAddressInfo)
        this.addressData = addressData
        this.province = addressData['100000']
    },
    methods:{
        changeProvince(val){
           this.city = this.addressData[val.name]
           if(!val){
               this.form.city = ''
               this.form.area = ''
           }
           this.$emit('change',this.form)
        },
        changeCity(val){
           this.area = this.addressData[val.name]
           if(!val){
               this.form.area = ''
           }
           this.$emit('change',this.form)
        },
        changeArea(val){
           this.$emit('change',this.form)
        }
    }
}
</script>

<style lang="scss" scoped>
.addressSelect{

}
</style>


// WEBPACK FOOTER //
// src/components/common/common/addressSelect.vue